module.exports = __webpack_public_path__ + "img/layout.4a340a6f.png";